import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const components = {
  a: ({ node, ...p }) => <a {...p} target="_blank" rel="noopener noreferrer nofollow" />,
  table: ({ node, ...p }) => <div className="wr-table-wrap"><table {...p} /></div>,
  img: () => null,
};

// Safe Markdown: raw HTML is skipped, images dropped, links open in a new tab.
export function MessageBody({ role, content }) {
  if (role === "user") return <span className="whitespace-pre-wrap">{content}</span>;
  return (
    <div className="wr-md" data-testid="assistant-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml components={components}>{content}</ReactMarkdown>
    </div>
  );
}
